<template>
        <div ref="cardview" class="card-view-div" :style="styleObj">
            <HomeHeader
                :returnLabel="i18n.tkey('lang_return')"
                :useChatBtn="false"
                @clickBackBtn="returnFunc"
                v-if="false !== fullScreen"
            />
            <el-scrollbar>
                <div class="card-view-content rotateY-div">
                    <div class="card-title-box">
                        <el-button @click="goRecommend" tkey="公司資訊">{{i18n.tkey("lang_company_news_info")}}</el-button>
                        <rotateButton style="position: absolute; right: 0; top: -75px; z-index: 9;font-size: calc(1.2em + 1px);color: #fff;" />
                        <rotateButton @click="changePageIndex" style="position: absolute; right: 0; top: -75px; z-index: 10" />

                    </div>

                    <div :class="pageIndex == 1 ? 'div-part-1' : 'div-part-2'">
                        <cardFace :htmlText="cardHtml" :webmem="cardAuth" :scaleWidth="scaleWidth"/>
                        <cardChatGroup :cardLgoin="cardLogin"/>
                        <cardMaterialGroup @clickAskBtn="goMaterialChat" :materialList="materialList"/>
                    </div>

                    <div :class="pageIndex == 2 ? 'div-part-1' : 'div-part-2'" v-if="!myCardTag">
                        <cardBacksideComponent v-if="null != currCard" :card="currCard" />
                        <pageTitle :titleText="i18n.tkey('lang_share_card')" />
                        <receiveCardShareBtnGroup v-if="null != currCard" :card="currCard" />
                    </div>

                    <div :class="pageIndex == 2 ? 'div-part-1' : 'div-part-2'" v-if="myCardTag">
                        <receiveCardShareQrcode v-if="null != currCard" :cardObj="currCard" />
                    </div>

                    <span>{{changeCard}}</span>
                </div>
            </el-scrollbar>

            <div class="card-animation-box" v-show="animationVisivle === true">
                <iframe :src="animationSrc" seamless="seamless"></iframe>
            </div>
        </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, onUnmounted, ref, computed, inject, toRef, onBeforeMount} from 'vue'
    import { useUserinfo } from '@/stores/userinfo'
    import { ElMessage } from 'element-plus'
    import cardFace from '@/components/cardFace.vue'
    import cardChatGroup from '@/components/cardChatGroup.vue'
    import cardMaterialGroup from '@/components/cardMaterialGroup.vue'
    import cardBacksideComponent from "@/components/shopopee/card/cardBacksideComponent"
    import receiveCardShareBtnGroup from "@/components/shopopee/share/receiveCardShareBtnGroup"
    import pageTitle from "@/components/shopopee/common/pageTitle"
    import rotateButton from "@/components/shopopee/button/rotateButton"
    import receiveCardShareQrcode from "@/components/shopopee/share/receiveCardShareQrcode"
    import record1Api from "@/request/record1Api";
    import cardApi from "@/request/api";
    import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
    import myUtil from "@/util/util";
    import {usePageinfo} from "@/stores/pageinfo";

    const emits = defineEmits(['sendMaterialChat'])
    const props = defineProps(['cardId', 'userLogin', 'isAllow', 'fullScreen'])

    const i18n = inject("i18n")

    const { proxy } = getCurrentInstance();
    const userInfoRef = toRef(useUserinfo())
    const pageInfoRef = toRef(usePageinfo())

    const { goCardRecommend } = inject('phoneView', { goCardRecommend: () => {} })

    const cardObj = {}
    const currCard = ref(null)
    const cardHtml = ref("")
    const cardAuth = ref(0)
    const scaleWidth = ref(425)
    const cardLogin = ref(null)
    const materialList = ref([])
    const animationVisivle = ref(false)
    const animationSrc = ref("")
    const backgroundImg = ref(null)
    const backgroundUrl = computed(() => {
        if (backgroundImg.value == null || backgroundImg.value === ""){
            return "#fff"
        }else{
            return `url(${proxy.$ShopopeeUrl}${backgroundImg.value})`
        }
    })
    const changeCard = computed(() => {
        if (null != props.cardId){
            let login = ""
            if (null != props.userLogin && "" !== props.userLogin){
                login = props.userLogin
            }else {
                login = userInfoRef.value.login
            }

            querySingleMemberwork(props.cardId, login, querySingleMemberworkCallback)
        }

        return ""
    })

    const pageIndex = ref(1)

    const myCardTag = computed(() => {
        let flag = false

        if (null != currCard.value && null != currCard.value.login){
            flag = userInfoRef.value.login == currCard.value.login
        }

        return flag
    })

    const styleObj = ref({
        background: backgroundUrl,
        width: "100%",
        height: "100%"
    })

    async function querySingleMemberwork(id, login, callback){
        const request = cardApi.querySingleMemberwork
        const params = request.getParams()

        params.id = id
        params.login = login

        request.send(params, (res) => {
            if (res.code == 200){
                if (typeof callback === "function"){
                    callback(res)
                }
            }else{
                if (typeof callback === "function"){
                    callback("")
                }
            }

        })

    }

    function querySingleMemberworkCallback(detail){
        if (detail.code == 200){
            detail = detail.detail
            currCard.value = detail
            Object.assign(cardObj, detail)
            cardHtml.value = cardObj.cardinfodesign
            cardLogin.value = cardObj.login
            cardAuth.value = cardObj.companyCardModel.webmem
            materialList.value = cardObj.materialList
            backgroundImg.value = cardObj.cardinfo2

            if (cardObj.cardinfodesign2 == 0){
                animationSrc.value = ""
                animationVisivle.value = false
            }else{
                animationSrc.value = `${proxy.$ShopopeeUrl}/include_memberwork_animate_${cardObj.cardinfodesign2}.html?id=${props.cardId}`
                animationVisivle.value = true
            }

            if (cardObj.record1Flag === true && props.isAllow === true){

            }

            setTimeout(() => {
                scaleWidth.value = proxy.$refs.cardview.clientWidth - 40

                if (scaleWidth.value > 425){
                    scaleWidth.value = 425
                }

            }, 50)

        }
    }

    function goMaterialChat(obj){
        if (obj.memberid == userInfoRef.value.id){
            ElMessage({
                showClose: true,
                message: i18n.tkey("lang_ask_item_alert_1"),
                type: 'error',
                appendTo: proxy.$refs.cardview,
                offset: 180
            })
        }else{
            const askUrl = myUtil.generateProductInfoUrl(obj.id)

            if(props.fullscreen === false){
                emits("sendMaterialChat", obj.login, askUrl)
            }else{
                pageInfoRef.value.chatLogin = obj.login
                pageInfoRef.value.chatSendMsg = askUrl

                proxy.$router.push({
                    name: "chat"
                })
            }

        }
    }

    function closeAnimaition(event) {
        if (event.data.type === "check"){
            animationSrc.value = ""
            animationVisivle.value = false

            if (props.isAllow === true){
                sendRequest(sendCallback)
            }
        }
    }

    async function sendRequest(callback){
        // const addinfo3 = props.isAllow === true ? 1 : 0
        const addinfo3 = 1

        const request = record1Api.sendRecord1
        const params = request.getParams()

        params.addinfo2 = props.cardId
        params.login = userInfoRef.value.login
        params.addinfo3 = addinfo3
        params.companycode = userInfoRef.value.companycode

        request.send(params, (res) => {
            if (typeof callback === "function"){
                callback(res)
            }
        })

    }

    function sendCallback(detail){
        if (detail.code == 200){
            ElMessage({
                showClose: true,
                message: i18n.tkey("lang_success_include"),
                type: 'success',
                appendTo: proxy.$refs.cardview,
                offset: 180
            })
        }else{
            ElMessage({
                showClose: true,
                message: i18n.tkey("lang_repeat_include_2"),
                type: 'success',
                appendTo: proxy.$refs.cardview,
                offset: 180
            })
        }
    }

    function goRecommend(){
        goCardRecommend(cardObj.companycode)
    }

    function changePageIndex(){
        pageIndex.value = pageIndex.value == 1 ? 2 : 1
    }

    function returnFunc(){
        // proxy.$router.back()
        let name = "myCard"

        if (myUtil.isEmpty(userInfoRef.value.login)){
            name = "index"
        }

        proxy.$router.push({
            name: name
        })
    }

    onBeforeMount(() => {
        if (props.fullScreen !== false){
            styleObj.value.width = `${window.innerWidth}px`
            styleObj.value.height = `${window.innerHeight}px`
        }
    })

    onMounted(() => {
        window.addEventListener("message", closeAnimaition)
    })

    onUnmounted(() => {
        window.removeEventListener("message", closeAnimaition)
    })
</script>

<style scoped>
    .card-view-div {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        //padding-left: 10px;
        //padding-right: 10px;
    }

    .card-animation-box {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: #ffffff;
        z-index: 20;
    }

    .card-animation-box iframe{
        width: 100%;
        height: 100%;
        border: 0;
    }

    .card-view-content {
        max-width: 425px;
        width: calc(100% - 30px);
        margin: auto;
        margin-top: 100px;
    }

    .rotateY-div {
        position: relative;
        transition: 0.5s ease;
        -moz-transition: 0.5s ease;
        -webkit-transition: 0.5s ease;
        -o-transition: 0.5s ease;
    }

    .rotateY-div .div-part-1 {
        position: absolute;
        /*background: #f9f9f9;*/
        background: transparent;
        width: 100%;
        border-radius: 20px;
        padding: 20px 0;
        backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        -o-backface-visibility: hidden;
        transform-style: preserve-3d;
        -moz-transform-style: preserve-3d;
        -webkit-transform-style: preserve-3d;
        -o-transform-style: preserve-3d;
        transition: 1s ease;
        -moz-transition: 1s ease;
        -webkit-transition: 1s ease;
        -o-transition: 1s ease;
        transform: rotateY(0deg);
        -moz-transform: rotateY(0deg);
        -webkit-transform: rotateY(0deg);
        -o-transform: rotateY(0deg);
        opacity: 1;
    }

    .rotateY-div .div-part-2 {
        position: absolute;
        /*background: #f9f9f9;*/
        width: 100%;
        border-radius: 20px;
        padding: 20px 0;
        /*background-color: #ffffff;*/
        background: transparent;
        backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        -o-backface-visibility: hidden;
        transform-style: preserve-3d;
        -moz-transform-style: preserve-3d;
        -webkit-transform-style: preserve-3d;
        -o-transform-style: preserve-3d;
        transition: 1s ease;
        -moz-transition: 1s ease;
        -webkit-transition: 1s ease;
        -o-transition: 1s ease;
        transform: rotateY(-180deg);
        -moz-transform: rotateY(-180deg);
        -webkit-transform: rotateY(-180deg);
        -o-transform: rotateY(-180deg);
        opacity: 0;
    }

    .card-title-box {
        text-align: left;
        margin-bottom: 5px;
        position: relative;
    }

</style>